import axios from 'axios'
import config from '../config'
import { addAuthToken } from '../helper'

const UsersManager = {
  getShellUserByToken: async ({ token }) => axios.request(addAuthToken({
    url: `${config.BASE_URL}/api/users/shell-token/${token}`,
    ...config.GET,
  })),
  verifyUniqueEmail: async ({ email }) => axios.request(addAuthToken({
    url: `${config.BASE_URL}/api/users/unique/email/${email}`,
    ...config.GET,
  })),
  verifyUsernameUnique: async ({ username }) => axios.request(addAuthToken({
    url: `${config.BASE_URL}/api/users/unique/username/${username}`,
    ...config.GET,
  })),
}

export default UsersManager
